module.exports = __webpack_public_path__ + "static/media/mac-now-logo-black.28514b1d.svg";